import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  MultiSelect,
  TextInput,
  Textarea,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositoryMdm, typeGv } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMDeliveryWork } from "../../../../model/TblDMDeliveryWork";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { useEffect } from "react";
import { handleKeyDown } from "../../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../../const/variables";

const CreateDataView = ({ onClose }: CreateDataViewProps) => {
  const entity = {
    id: "0",
    code: "",
    name: "",
    note: null,
    active: false,
    department: null,
    lastUpdateDate: null,
    createBy: null,
    createDate: null,
    lastUpdateBy: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<TblDMDeliveryWork>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên công việc giao vận!";
        }
        return hasLength(
          { min: 5, max: 100 },
          "Tên phải từ 5-100 kí tự!",
        )(value as string);
      },
      code: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã công việc!";
        }
        return hasLength(
          { max: 50 },
          "Mã phải nhỏ hơn 50 kí tự!",
        )(value as string);
      },
      note: (value: string | null) => {
        if (value) {
          return hasLength(
            { max: 225 },
            "Ghi chú phải nhỏ hơn 225 kí tự!",
          )(value as string);
        }
      },
      department: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn BPGV áp dụng !";
        }
      },
    },
  });

  const callApiGetData = async () => {
    open();
    const callApi = await repositoryMdm.get<MessageResponse<TblDMDeliveryWork>>(
      "/api/v1/TblDmDeliveryWork/create",
    );
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Bạn không có quyền tạo!!!");
      modals.closeAll();
    }
  };

  const handleCreateTblDMDeliveryWork = async (
    dataSubmit: TblDMDeliveryWork,
  ) => {
    open();
    const dataApi = await repositoryMdm.post<
      MessageResponse<TblDMDeliveryWork>
    >("/api/v1/TblDMDeliveryWork/create", dataSubmit);
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
      NotificationExtension.Success("Thêm thành công !");
    }
    close();
  };

  useEffect(() => {
    callApiGetData();
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        w={{ base: "280px", md: "336px", lg: "448px" }}
        onSubmit={form.onSubmit((e: TblDMDeliveryWork) => {
          handleCreateTblDMDeliveryWork(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={4}>
            <TextInput
              label={"Mã công việc giao vận"}
              placeholder={"Nhập mã"}
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("code")}
            />
          </Grid.Col>
          <Grid.Col span={8}>
            <TextInput
              label={"Tên công việc giao hàng"}
              placeholder={"Nhập tên"}
              withAsterisk
              {...form.getInputProps("name")}
            />
          </Grid.Col>
        </Grid>
        <Grid align="center">
          <Grid.Col span={12}>
            <MultiSelect
              label="BPGV áp dụng"
              placeholder="Chọn BPGV áp dụng"
              data={[
                { label: "Tất cả", value: "all" },
                ...typeGv.filter((i) => i.value !== "5"),
              ]}
              value={
                form.getValues().department
                  ? form.getValues().department?.split(",")
                  : []
              }
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => {
                if (e.includes("all")) {
                  form.setValues((prev) => ({
                    ...prev,
                    department: typeGv
                      .filter((i) => i.value !== "5")
                      .map((i) => i.value.trim())
                      .join(","),
                  }));
                } else {
                  form.setValues((prev) => ({
                    ...prev,
                    department: e.join(","),
                  }));
                }
              }}
            />
          </Grid.Col>
        </Grid>
        <Grid align="center">
          <Grid.Col span={12}>
            <Textarea
              label={"Ghi chú"}
              placeholder="Nhập ghi chú"
              w={"100%"}
              {...form.getInputProps("note")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox label={"Sử dụng"} {...form.getInputProps("active")} />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateDataView;

type CreateDataViewProps = {
  onClose: any;
};
